import StoreService from '@topgeschenken/front-library/services/StoreService';

const BASE_ENDPOINT = '/order/order-collections';
const storeService = new StoreService(BASE_ENDPOINT);

const state = () => ({
  ...storeService.getState(),
});

const actions = {
  ...storeService.getActions(),
};

const mutations = {
  ...storeService.getMutations(),
};

const getters = {
  ...storeService.getGetters(),
};

export default {
  state,
  mutations,
  actions,
  getters,
};
